import React from "react";
import { DebounceInput } from "react-debounce-input";

export default function ProductOverviewSearch({ query, updateQuery }) {
    return (
        <div className="filter__search">
            <DebounceInput
                autoComplete="off"
                id="query"
                debounceTimeout={500}
                type="text"
                className="form-control form-control--search text-truncate"
                placeholder="Zoeken..."
                value={query}
                name={query?.length > 0 ? "query" : ""}
                onChange={event => {
                    event.preventDefault();
                    updateQuery(event.target.value)
                }}
            />
        </div>
    );
}
